var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { Storage } from "../../../../lib/localstorege.service";
import { Api } from "./game.operations.api";
import { currencyFormat, dateTimeFormat, initialLeftMenu, sportsMenu, useForceUpdate } from "../../../../lib/misc.functions";
import { modalServiceSubject } from "../../../../components/modal/modal";
import { useNavigate } from "react-router-dom";
import { isMobile } from "../../../../app/Routes";
import { GameOperationsSelect } from "../../widgets/selected";
import IddaaDetail from "../../widgets/modal/iddaa.detail";
import Clock from "../../../../assets/feather/clock.svg";
import CheckCircle from "../../../../assets/feather/check-circle.svg";
import MinusCircle from "../../../../assets/feather/minus-circle.svg";
import iconSave from "../../../../assets/feather/save-dark.svg";
import { env } from "../../../../definitions/global.vars";
import { Subject } from "rxjs";
import { ApiService } from "../../../../lib/http.service";
import { betSlipActionSubject, BetSlipOption } from "../../../../store/betslip.store";
var page = 0;
var hasMore = true;
var paramStates = {
    "devam-edenler": 1,
    "kazanan": 2,
    "kaybeden": 3,
    "kayitli": 5,
};
var states = {
    1: 'devam eden',
    2: 'kazanan',
    3: 'kaybeden',
    5: 'kayıtlı',
};
var couponStatus = {
    0: _jsx("img", { src: Clock, className: "invert-color", width: 16 }, void 0),
    1: _jsx("img", { src: Clock, className: "invert-color", width: 16 }, void 0),
    2: _jsx("img", { src: CheckCircle, width: 16 }, void 0),
    3: _jsx("img", { src: MinusCircle, width: 16 }, void 0),
    5: _jsx("img", { src: iconSave, width: 16 }, void 0),
};
export var couponDetailSubject = new Subject();
var Iddia = function (props) {
    var navigate = useNavigate();
    var params = props.params;
    // @ts-ignore
    var iddiaStatus = paramStates[params.couponId];
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "widget card" }, { children: [_jsxs("div", __assign({ className: "header" }, { children: [isMobile ? _jsx(GameOperationsSelect, {}, void 0) : _jsx("h1", { children: "\u0130ddaa Kuponlar\u0131m" }, void 0), _jsxs("ul", __assign({ className: "tabs clearfix" }, { children: [_jsx("li", __assign({ className: "cursor-pointer tab " + (iddiaStatus < 2 ? 'active' : ''), onClick: function () { return navigate('/hesabim/iddaa/devam-edenler'); } }, { children: "Devam Eden" }), void 0), _jsx("li", __assign({ className: "cursor-pointer tab " + (iddiaStatus === 2 ? 'active' : ''), onClick: function () { return navigate('/hesabim/iddaa/kazanan'); } }, { children: "Kazanan" }), void 0), _jsx("li", __assign({ className: "cursor-pointer tab " + (iddiaStatus === 3 ? 'active' : ''), onClick: function () { return navigate('/hesabim/iddaa/kaybeden'); } }, { children: "Kaybeden" }), void 0), _jsx("li", __assign({ className: "cursor-pointer tab " + (iddiaStatus === 5 ? 'active' : ''), onClick: function () { return navigate('/hesabim/iddaa/kayitli'); } }, { children: "Kay\u0131tl\u0131" }), void 0)] }), void 0)] }), void 0), _jsxs("div", __assign({ id: "InfiniteScroll", className: "body p-0 " }, { children: [_jsx(ListCoupons, { params: params }, void 0), _jsx(IddaaDetail, {}, void 0)] }), void 0)] }), void 0) }, void 0));
};
export default Iddia;
var iddiaData = [];
var lockScroll = false;
var iddiaStatus = 1;
var timer = null;
var checkTimer;
var maxRatioPoint = null;
export function ListCoupons(props) {
    var forceUpdate = useForceUpdate();
    var params = props.params;
    useEffect(function () {
        window.scrollTo(0, 0);
        iddiaData = [];
        var cachedPoint = Storage.get('cached_available_bonus');
        if (cachedPoint) {
            maxRatioPoint = Number(cachedPoint);
            fetchData(true);
        }
        else {
            var api = new ApiService();
            api.start('post', env.accounting_api + '/marketing/api/available-bonus/', Storage.get('token') ? { token: Storage.get('token') } : null, true, 3000)
                .then(function (res) {
                Storage.set('cached_available_bonus', res.data.available_bonus, 60 * 1000);
                maxRatioPoint = Number(res.data.available_bonus);
                fetchData(true);
            });
        }
    }, [params.couponId]);
    useEffect(function () {
        var betSlipActionSubject_subscription = betSlipActionSubject.subscribe(function () {
            if ((BetSlipOption.bettingInfoStatus === 1) ||
                (BetSlipOption.bettingInfoStatus === 2) ||
                (BetSlipOption.bettingInfoStatus === 3)) {
                window.scrollTo(0, 0);
                fetchData(true, 0, 0);
            }
        });
        return function () {
            betSlipActionSubject_subscription.unsubscribe();
        };
    }, []);
    // @ts-ignore
    iddiaStatus = paramStates[params.couponId];
    var fetchData = function (isFirst, forcePage, top) {
        if (isFirst === void 0) { isFirst = false; }
        if (forcePage === void 0) { forcePage = null; }
        if (top === void 0) { top = null; }
        try {
            // @ts-ignore
            document.getElementById('loadingAnimation').style.display = 'block';
            hasMore = false;
            if (isFirst) {
                iddiaData = [];
                page = forcePage !== null ? forcePage : 0;
                hasMore = true;
            }
            var data = {
                token: Storage.get('token'),
                status: iddiaStatus < 2 ? '0,1' : iddiaStatus,
                page: page
            };
            // @ts-ignore
            var objectHeight_1 = document.getElementById('InfiniteScroll').offsetHeight;
            // @ts-ignore
            var objectTop_1 = document.getElementById('InfiniteScroll').offsetTop;
            Api.start('post', env.core_api + '/order/api/orders/iddaa/', data, true, 10000).then(function (result) {
                // @ts-ignore
                document.getElementById('loadingAnimation').style.display = 'none';
                if (result.status) {
                    if (result.data.length < 1) {
                        hasMore = false;
                        lockScroll = true;
                    }
                    else {
                        hasMore = true;
                    }
                    page += 1;
                    if (isFirst) {
                        iddiaData = result.data;
                    }
                    else {
                        iddiaData = iddiaData.concat(result.data);
                    }
                    forceUpdate();
                    if (!isFirst) {
                        if (top === 0) {
                            window.scrollTo(0, top);
                        }
                        else {
                            var threshold = window.outerHeight < 700 ? 600 : 700;
                            window.scrollTo(0, (objectHeight_1 - objectTop_1 - threshold));
                        }
                    }
                    timer = setTimeout(function () {
                        if (result.data.length >= 1) {
                            lockScroll = false;
                            if (iddiaData.length === 20 && objectHeight_1 < window.outerHeight) {
                                fetchData(false, 1, 0);
                            }
                        }
                        triggerScroll();
                    }, 500);
                }
                else {
                    modalServiceSubject.next({
                        title: 'beklenmedik bir sorun',
                        content: result.message,
                        confirm: {
                            cancel: { label: 'Tamam' }
                        },
                        timeout: 3000,
                    });
                }
            });
        }
        catch (e) {
        }
    };
    useEffect(function () {
        window.addEventListener('scroll', triggerScroll);
        return function () {
            clearTimeout(timer);
            window.removeEventListener('scroll', triggerScroll);
        };
    }, []);
    var triggerScroll = function () {
        var threshold = window.outerHeight < 968 ? 100 : 150;
        // @ts-ignore
        var objectHeight = document.getElementById('InfiniteScroll').offsetHeight;
        // @ts-ignore
        var objectTop = document.getElementById('InfiniteScroll').offsetTop;
        var visibleZone = (window.outerHeight - objectTop - threshold);
        if (objectHeight > visibleZone) {
            if ((objectHeight - visibleZone) < window.scrollY && !lockScroll) {
                lockScroll = true;
                fetchData(false);
            }
        }
    };
    var openCouponDetail = function (data) {
        if (data.status === 0) {
            modalServiceSubject.next({
                title: 'Kuponunuz oynanıyor',
                content: "Hen\u00FCz kupon oynama i\u015Flemi tamamlanmad\u0131 l\u00FCtfen bekleyiniz.<p>, ".concat(data.pending_quantity, " adet onay bekliyor. </p>"),
                confirm: {
                    cancel: {
                        label: 'Tamam'
                    }
                }
            });
        }
        else {
            couponDetailSubject.next(data);
        }
    };
    var apiService = new ApiService();
    var checkLiveCoupons = function (coupon_ids) {
        console.log("check");
        var updateData = {
            coupon_id_list: coupon_ids.join(','),
            token: Storage.get('token')
        };
        apiService.start('post', env.core_api + '/order/api/get_coupon_status/', updateData, true)
            .then(function (response) {
            if (response.status) {
                if (response.data.filter(function (el) { return el.status === 0; }).length > 0) {
                    response.data.forEach(function (c) {
                        if (Number(c.pending_quantity) === 0 && Number(c.status) === 1) {
                            var cop = iddiaData.find(function (el) { return el.id === c.id; });
                            if (cop) {
                                cop.status = c.status;
                                cop.approve_date = c.approve_date;
                                cop.approve_code = c.approve_code;
                                cop.coupon_quantity = c.coupon_quantity;
                                cop.pending_quantity = c.pending_quantity;
                            }
                            iddiaData[iddiaData.indexOf(cop)] = cop;
                            console.log("oynandı bitti");
                        }
                        else if (Number(c.pending_quantity) > 0 && Number(c.status) === 0) {
                            var cop = iddiaData.find(function (el) { return el.id === c.id; });
                            if (cop) {
                                cop.status = c.status;
                                cop.approve_date = c.approve_date;
                                cop.approve_code = c.approve_code;
                                cop.coupon_quantity = c.coupon_quantity;
                                cop.pending_quantity = c.pending_quantity;
                            }
                            iddiaData[iddiaData.indexOf(cop)] = cop;
                            console.log("devam ediyor");
                        }
                        else if (Number(c.pending_quantity) === 0 && Number(c.status) !== 0) {
                            var cop = iddiaData.find(function (el) { return el.id === c.id; });
                            iddiaData.splice(iddiaData.indexOf(cop), 1);
                            console.log("oynanamadı");
                        }
                    });
                }
            }
            clearTimeout(checkTimer);
            forceUpdate();
        });
    };
    var pendingCounpons = iddiaData.filter(function (el) { return el.status === 0; });
    if (pendingCounpons.length > 0) {
        checkTimer = setTimeout(function () {
            var coupon_ids = pendingCounpons.map(function (el) { return el.id; });
            checkLiveCoupons(coupon_ids);
        }, 3000);
    }
    else {
        clearTimeout(checkTimer);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("table", __assign({ className: "table" }, { children: [_jsx(Title, {}, void 0), _jsx("tbody", { children: iddiaData.map(function (data, key) {
                            data.profit = (Number(data.profit) * Number(data.coupon_quantity));
                            data.extraProfit = (Number(data.multiply) * Number(data.coupon_quantity) * Number(data.additional_ratio));
                            if (maxRatioPoint !== null && data.extraProfit > maxRatioPoint) {
                                data.extraProfit = maxRatioPoint;
                            }
                            return (_jsxs("tr", __assign({ onClick: function () {
                                    openCouponDetail(data);
                                }, className: "cursor-pointer", id: data.id }, { children: [_jsx("td", __assign({ className: "text-center hidden-sm" }, { children: data.status === 0 || data.pending_quantity > 0 ? _jsx(_Fragment, { children: "Kupon Oynan\u0131yor" }, void 0) : _jsx(_Fragment, { children: data.approve_code }, void 0) }), void 0), _jsx("td", __assign({ className: "text-center" }, { children: data.approve_date ? dateTimeFormat(data.approve_date) : dateTimeFormat(data.create_date) }), void 0), _jsx("td", __assign({ className: "text-center" }, { children: data.status === 0 || data.pending_quantity > 0 ? _jsx(_Fragment, { children: "Kupon Oynan\u0131yor" }, void 0) : _jsxs(_Fragment, { children: [currencyFormat(Number(data.amount) / (data.unit === 0 || data.unit === 2 ? 1 : 100) * Number(data.coupon_quantity)), " \u20BA"] }, void 0) }), void 0), _jsx("td", __assign({ className: "text-center" }, { children: data.status === 0 || data.pending_quantity > 0 ? _jsx(_Fragment, { children: "Kupon Oynan\u0131yor" }, void 0) : _jsx(_Fragment, { children: (Number(data.total_ratio) + Number(data.additional_ratio)).toFixed(2) }, void 0) }), void 0), _jsx("td", __assign({ className: "text-center hidden-sm" }, { children: data.status === 0 || data.pending_quantity > 0 ? _jsx(_Fragment, { children: "Kupon Oynan\u0131yor" }, void 0) : _jsxs(_Fragment, { children: [Number(data.additional_ratio) > 0 || Number(data.additional_point) > 0 ? _jsx(_Fragment, { children: _jsxs("span", __assign({ style: { textDecoration: "line-through" } }, { children: [currencyFormat(Number(data.profit)), "\u20BA "] }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), data.status === 2 ? _jsxs(_Fragment, { children: [currencyFormat(Number(data.winning) + Number(data.additional_point)), "\u20BA"] }, void 0) : _jsxs(_Fragment, { children: [currencyFormat(Number(data.extraProfit) + Number(data.profit)), "\u20BA"] }, void 0)] }, void 0) }), void 0), _jsx("td", { children: couponStatus[data.status] }, void 0)] }), "accountIddıa" + key));
                        }) }, void 0)] }), void 0), hasMore == false && iddiaData.length === 0 ? _jsx(_Fragment, { children: _jsxs("p", __assign({ className: "text-center py-5" }, { children: ["Listelenecek ", states[iddiaStatus], " kuponunuz bulunmamaktad\u0131r."] }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), _jsx("div", __assign({ id: "loadingAnimation", className: "text-center py-5" }, { children: _jsxs("div", __assign({ className: "lds-roller", style: { position: 'unset' } }, { children: [_jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0)] }), void 0) }), void 0)] }, void 0));
}
var Title = function () {
    return (_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-center hidden-sm" }, { children: "Kupon No" }), void 0), _jsx("th", __assign({ className: "text-center" }, { children: "Tarih" }), void 0), _jsx("th", __assign({ className: "text-center" }, { children: "Kupon Tutar\u0131" }), void 0), _jsx("th", __assign({ className: "text-center" }, { children: "Oran" }), void 0), _jsx("th", __assign({ className: "text-center hidden-sm" }, { children: "Kazan\u00E7" }), void 0), _jsx("th", __assign({ className: "text-center" }, { children: "Durum" }), void 0)] }, void 0) }, void 0));
};
